<!-- ============================================================== -->
<!-- Sidebar Toggle button - -->
<!-- ============================================================== -->
<button type="button" mat-button mat-icon-button (click)="sidebartoggle.toggle()">
    <i-feather class="feather-20 text-light" name="menu"></i-feather>
</button>
<!-- ============================================================== -->
<!-- Search Toggle button - -->
<!-- ============================================================== -->
<button mat-icon-button mat-button class="srh-btn" (click)="showSearch = !showSearch">
    <i-feather class="feather-20 text-light" name="search"></i-feather>
</button>

<div *ngIf="showSearch" class="topsearch hstack gap-3 align-items-center">
    <mat-form-field class="w-100" color="accent" appearance="fill">
        <input matInput placeholder="Search Dashboard" class="mat-textsmall" />
    </mat-form-field>
    <mat-icon (click)="showSearch = !showSearch" class="cursor-pointer">
        close
    </mat-icon>
</div>
<!-- ====================================== -->
<!-- this is in use do not delete -->
<span fxFlex></span>
<!-- ====================================== -->
<button [matMenuTriggerFor]="stickyNotes" mat-button mat-icon-button class="m-r-5 position-relative"
matTooltip="Widgets" >
    <i class="flaticon-menu-1"></i>
</button>
<mat-menu #stickyNotes="matMenu" class="extendedMenu">
    <button mat-menu-item class="extendedMenuBtn" (click)="openNotes()">
        <i class="flaticon-paper"></i> <span>Notes</span>
    </button>
    <button mat-menu-item class="extendedMenuBtn" (click)="openCalculator()">
        <i class="flaticon-accounting"></i> <span>Calculator</span>
    </button>
</mat-menu>

<button mat-button mat-icon-button class="m-r-5 position-relative" (click)="gotoApp()"
        matTooltip="Arthkosh">
    <i class="flaticon-coin"></i>
</button>

<button mat-button mat-icon-button class="m-r-5 position-relative" (click)="openSuggestion()"
        matTooltip="LOGzy Community">
    <!-- <i-feather class="feather-20 text-light" name="heart"></i-feather> -->
    <i class="flaticon-customer-support"></i>
</button>

<!-- test for text -->
<!-- <button mat-icon-button  class="fontSetter fsSmall" [class.selectedFont]="selectedFont==='small'" (click)="setFontSize('small','12px')" >A</button>
<button mat-icon-button  class="fontSetter fsMedium" [class.selectedFont]="selectedFont==='medium'" (click)="setFontSize('medium','14px')" >A</button>
<button mat-icon-button  class="fontSetter fsLarge" [class.selectedFont]="selectedFont==='large'" (click)="setFontSize('large','15px')" >A</button> -->
<button mat-button mat-icon-button class="m-r-5 position-relative" matTooltip="Chat" (click)="openChat()">
    <i-feather class="feather-20 text-light" name="message-circle"></i-feather>
    <div *ngIf="chatService.unreadChatCount > 0">
        <div class="notify">
            <span [ngClass]="chatService.unreadChatCount > 0 ? 'point bg-primary' : 'point bg-accent'"></span>
        </div>
        <!-- <span class="point">{{ chatService.unreadChatCount < 10 ? chatService.unreadChatCount :
                (chatService.unreadChatCount + '+' ) }}</span> -->
    </div>
</button>

<!-- ============================================================== -->
<!-- Messages - style you can find in header.scss -->
<!-- ============================================================== -->
<!-- <button mat-button mat-icon-button class="m-r-5 position-relative" [matMenuTriggerFor]="message"
    [disabled]="chatNotifications.length == 0">
    <i-feather class="feather-20 text-light" name="message-square"></i-feather>
    <div class="notify">
        <span [ngClass]="chatNotifications.length != 0 ? 'point bg-primary' : 'point bg-accent'"></span>
    </div>
</button> -->
<mat-menu #message="matMenu" class="topbardd">
    <!-- <mat-action-list class="m-b-10"> -->
    <!-- <h4 class="ddheadtitle m-0 m-b-5 m-r-10 hstack align-items-center">
            Messages
            <div class="m-l-10">
                <mat-chip-list>
                    <mat-chip color="primary" selected>5 new</mat-chip>
                </mat-chip-list>
            </div>
        </h4> -->
    <!-- <mat-list-item *ngFor="let notification of chatNotifications; last as last"
            (click)="clearMsgNotification(notification)"> -->
    <!-- <div mat-list-icon class="mat-list-item-img">
                <img src="{{ message.img }}" alt="users" class="w-100" />
            </div> -->

    <!-- <h6 mat-line class="ddtitle">{{ message.title }}</h6> -->

    <!-- <div mat-line class="text-muted" style="font-size: smaller"><span style="color: red;">{{
                    notification.unread_count }}</span> unread
                messages in
                <span style="color: red;">{{ notification.name }}</span>
            </div> -->
    <!-- <div mat-line class="text-muted">{{ message.time }}</div> -->
    <!-- <mat-divider *ngIf="!last"></mat-divider> -->
    <!-- </mat-list-item> -->
    <!-- </mat-action-list> -->
    <!-- <button mat-flat-button color="accent" class="w-100">
        See all messages
    </button> -->
</mat-menu>

<!-- ============================================================== -->
<!-- Notification - style you can find in header.scss -->
<!-- ============================================================== -->
<button [matMenuTriggerFor]="notification" mat-button mat-icon-button class="m-r-5 position-relative"
        matTooltip="Notifications"
        (click)="readNotification()">
    <!-- [disabled]="newNotifications.length == 0" -->
    <i-feather class="feather-20 text-light" name="bell"></i-feather>
    <div class="notify">
        <span [ngClass]="newNotificationFlag == true ? 'point bg-primary' : 'point bg-accent'"></span>
    </div>
    <!-- <div class="notify" style="top: -8px !important; color: red">
        <span class="blink">{{ newNotification.length }}</span>
    </div> -->
</button>
<mat-menu #notification="matMenu" class="topbardd">
    <mat-action-list class="m-b-10">
        <h4 class="ddheadtitle m-0 m-b-15 m-r-10 hstack align-items-center">
            Notifications
            <!-- <div class="m-l-10">
                <mat-chip-list>
                    <mat-chip color="accent" selected>5 new</mat-chip>
                </mat-chip-list>
            </div> -->
        </h4>

        <div class="notificationList" [class.justify-content-center]="newNotifications?.length<1"
             [class.d-flex]="newNotifications?.length<1">
            <mat-list-item *ngFor="let notification of newNotifications; last as last" class="matListItem"
                           (click)="loadRequest(notification)">
                <div class="bg text-white" mat-list-icon>
                    <!-- <mat-icon> -->
                    <i class="flaticon-{{notification.icon_class != null ? notification.icon_class : 'documents'}}"></i>
                    <!-- {{ notification.icon }} -->
                    <!-- </mat-icon> -->
                </div>
                <div mat-line class="text-muted notificationMessage" style="white-space: pre-wrap;">{{
                        notification.message
                    }}
                </div>
                <span matLine></span>
                <span mat-line class="ddtitle">
                    <!-- {{ notification.title }} -->
                    <!-- <small class="notificationTime"> -->
                    {{notification.created_at | date: 'd-MMM h:mm a'}}
                    <!-- </small> -->
                </span>
                <mat-divider *ngIf="!last"></mat-divider>
            </mat-list-item>
            <div class="notificationCaught">
                <logzy-img-loader *ngIf="newNotifications?.length<1"
                                  src="/assets/images/backgrounds/notification_all_viewed.png" border_radius="">
                </logzy-img-loader>
                <span *ngIf="newNotifications?.length<1">All caught up!</span>
            </div>
        </div>
        <div (click)="$event.stopPropagation();">
            <button *ngIf="nextPage != null" mat-flat-button color="accent" class="w-100" (click)="loadMore()">
                See more notifications
            </button>
        </div>
    </mat-action-list>
</mat-menu>
<!-- ============================================================== -->
<!-- User Profile - style you can find in header.scss // current in use -->
<!-- ============================================================== -->
<button mat-icon-button [matMenuTriggerFor]="profile" class="text-light m-l-10">
    <logzy-img-loader src="{{profile_pic == null ? current_user?.gender == 'Male'
                    ? base_url + '/media/profile_pics/man.svg'
                    : current_user?.gender == 'Female'
                    ? base_url + '/media/profile_pics/woman.svg'
                    : base_url + '/media/profile_pics/default_dp.svg' : profile_pic?.document_file}}"
                      border_radius="50%" class="profile-logo-round" [profilePic]="true"
                      [initials]="current_user?.initials">
    </logzy-img-loader>
    <!-- @TODO show initals on broken profile picture -->
    <!-- <span class="bgc-purple" *ngIf="current_user?.picture==null">{{current_user?.initials}}
  </span> -->
</button>
<mat-menu #profile="matMenu" class="topbardd">
    <div class="main" (mousemove)="onMouseMove($event)">
        <div class="bgImg">
            <div #Div class="right_vector"></div>
            <div #Div1 class="left_vector"></div>
            <div class="hstack justify-content-center gap-3">
                <logzy-img-loader [src]="profile_pic == null ? current_user?.gender == 'Male'
                                ? base_url + '/media/profile_pics/man.svg'
                                : current_user?.gender == 'Female'
                                ? base_url + '/media/profile_pics/woman.svg'
                                : base_url + '/media/profile_pics/default_dp.svg' : profile_pic?.document_file"
                                  class="rounded-circle profile-logo-round" border_radius="50%" [profilePic]="true"
                                  routerLink="my-account/" [initials]="current_user?.initials">
                </logzy-img-loader>

                <!-- <span class="bgc-purple" *ngIf="current_user?.picture==null">{{current_user?.initials}}
        </span> -->
            </div>
            <div class="user-details">
                <h5 routerLink="my-account/">
                    {{current_user?.first_name}} {{current_user?.last_name}}
                </h5>
                <span class="fw-normal fs-14">{{current_user?.email}}</span>
            </div>
        </div>
        <div class="links">
            <div class="manageAcc">
                <h5 class="fw-normal">{{current_user?.profile_role}}</h5>
                <span class="fs-14">You're a member since </span><br />
                <span class="fs-14 fw-bold">
                    {{current_user?.created_at | date : "dd MMM yyyy"}}</span><br />
                <span class="link" routerLink="my-account/">Manage Your Account</span>
            </div>
            <div class="abstract">
                <!-- <img src="assets/images/backgrounds/profile_abstract.jpg"> -->
                <!-- <span class="material-symbols-outlined" (click)="signOut()">
          power_settings_new
        </span> -->
                <!-- <h5 class="fw-normal">{{current_user?.profile_role}}</h5> -->
                <span class="logout" (click)="signOut()">
                    <i class="flaticon-logout"></i> Logout</span>
                <!-- <h6 mat-line class="ddtitle">My Profile</h6> -->
            </div>
        </div>
    </div>
    <!-- <mat-action-list class="m-b-10">
    <h4 class="ddheadtitle m-0 m-b-5">User Profile</h4>
    <div class="hstack align-items-center gap-3 p-t-15 p-b-15">
      <img src="assets/images/users/user.jpg" width="80" class="rounded-circle" alt="" />
      <div>
        <h4 class="m-0">Julia Roberts</h4>
        <h5 class="text-muted m-0 fw-normal">Administrator</h5>
      </div>
    </div>
    <mat-divider></mat-divider>
    <div *ngFor="let profile of profiles; last as last">
      <mat-list-item>
        <mat-divider *ngIf="!last"></mat-divider>
        <div class="mat-list-item-img bg-light-{{ profile.bg }}" mat-list-icon>
          <i-feather name="{{ profile.icon }}" class="text-{{ profile.bg }}"></i-feather>
        </div>

        <h6 mat-line class="ddtitle">{{ profile.title }}</h6>
        <span mat-line></span>
        <div mat-line class="text-muted">{{ profile.subject }}</div>
      </mat-list-item>
    </div>
  </mat-action-list>
  <button mat-flat-button color="accent" (click)="signOut()" class="w-100">Logout</button> -->
</mat-menu>